import './Header.css';

const Header = () => {
  return (
    <header>
      <h1 className="logo --no-select">Stonecoal</h1>
      <div className="description --no-select">The cheesiest Dutch–English translator on the Internet</div>
    </header>
  );
}

export default Header;
